<template>
	<div>
		<h3 class="popup-tilte">Tájékoztató</h3>
		<div class="fs-desc mb-30px popup-content-width">
			<span class="text-center d-table w-100">Tisztelt Látogató!</span>
			<br />
			Amennyiben az alábbi rövid regisztrációval megerősíti érdeklődését, abban az esetben a megadott elektronikus
			levélcímre megerősítő levelet fog kapni tőlünk, mely tartalmazza az Összehasonlító oldal megnyitásához
			szükséges linket.
			<br />
			<br />
			Az Összehasonlító oldalon egyszerűen összehasonlítható, táblázatos formában megtekinthető ajánlatok a
			biztosító nevét, a biztosítás fizetési ütemezését, a biztosítási összeget, a biztosítás csomagját
			(alapcsomag, kiegészítők), valamint a biztosítási díjat is tartalmazzák. Az Összehasonlító oldal használata
			megkönnyíti a tájékozódást, és a Minősített Fogyasztóbarát Otthonbiztosítás ajánlatok összehasonlítását.
			<br />
			<br />
			Felhívjuk figyelmét, hogy az
			<b>Eurorisk</b>
			-
			<i>mint független biztosításközvetítő (biztosítási alkusz)</i>
			-
			<b>nem minősül a biztosító képviselőjének.</b>
			Kínálatunkban csak azok a biztosítótársaságok szerepelnek, amelyek a Minősített Fogyasztóbarát
			Otthonbiztosítási ajánlatokat úgynevezett webszervíz technológiával nyújtják. Ez azt jelenti, hogy az
			<b>E-otthonbiztositas.hu</b>
			oldalon Ön által végzett kalkulációk esetén az adatok a biztosítók által szolgáltatott adatbázisokból
			származnak.
			<br />
			<br />
			<b>
				A lenti „Regisztráció” kitöltésével és elküldésével Ön a fenti tájékoztatás tudomásul vételét is
				tanúsítja.
			</b>
		</div>
		<h3 class="popup-tilte">Regisztráció</h3>

		<ValidationObserver ref="form" slim v-slot="{ invalid }">
			<div class="popup-form form">
				<ValidationProvider
					name="Vezetéknév"
					rules="required|letter_space_hypens"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="float-left w-50 mb-30px">
						<div :class="classes">
							<input
								type="text"
								placeholder="Vezetéknév"
								class="mw-250px d-table ml-auto"
								v-model="user.last_name"
								inputmode="text"
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="Keresztnév"
					rules="required|letter_space_hypens"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="d-table w-50 mb-30px">
						<div :class="classes">
							<input
								type="text"
								placeholder="Keresztnév"
								class="mw-250px d-table mr-auto"
								v-model="user.first_name"
								inputmode="text"
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="Telefonszám"
					rules="required|phone"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="float-left w-50 mb-30px">
						<div class="telInput w-100" :class="classes">
							<input
								placeholder="Telefonszám"
								type="text"
								class="mw-250px d-table ml-auto"
								v-model="user.phone"
								inputmode="tel"
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="E-mail cím"
					rules="required|email"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="d-table w-50 mb-30px">
						<div :class="classes">
							<input 
								type="email" 
								placeholder="E-mail cím" 
								class="mw-250px d-table mr-auto" 
								v-model="user.email" 
								inputmode="email" 
								data-hj-allow
							/>
						</div>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="Jelszó"
					rules="required|password"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="d-table w-100 mb-30px" :class="classes">
						<input type="password" placeholder="Jelszó" v-model="user.password" data-hj-allow/>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="Jelszó ismétlés"
					rules="required|password|confirm:@Jelszó"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="d-table w-100 mb-30px" :class="classes">
						<input type="password" placeholder="Jelszó ismétlés" v-model="user.password_repeat" data-hj-allow/>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider
					name="Adatkezelés"
					:rules="{ required: { allowFalse: false } }"
					v-slot="{ errors, classes }"
					slim
					mode="eager"
				>
					<div class="col-w100-chbox chbox_style-wrapper mb-15px" :class="classes">
						<input type="checkbox" id="privacyPolicy" class="field" v-model="user.terms" data-hj-allow/>
						<span class="chbox_style"></span>
						<label for="privacyPolicy">
							Elolvastam és elfogadom az
							<a href="/adatvedelem" target="_blank">Adatkezelésről</a>
							szóló tájékoztatóban foglaltakat.
						</label>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<ValidationProvider name="Feliratkozás" rules="" v-slot="{ errors, classes }" slim>
					<div class="col-w100-chbox chbox_style-wrapper mb-30px" :class="classes">
						<input type="checkbox" id="opt05" class="field" v-model="user.subscribe" data-hj-allow/>
						<span class="chbox_style"></span>
						<label for="opt05">
							Hozzájárulok, hogy az Eurorisk Kft. a szolgáltatásaival kapcsolatos hírlevelet küldjön a
							részemre.
						</label>
						<span class="error_message error_message--broke">{{ errors[0] }}</span>
					</div>
				</ValidationProvider>

				<span class="d-flex error_message error_message--broke justify-center mb-15px mt-12px" v-if="error">
					{{ error }}
				</span>

				<LoadingButton
					class="btn btn-blue m-auto"
					text="Regisztráció"
					:disabled="invalid"
					@click="handleRegistration"
					:loading="getLoading"
				/>
				<a
					href="javascript:void(0);"
					class="d-flex justify-center m-auto mt-12px w-100"
					@click="showPopup('Login')"
				>
					Már van fiókom
				</a>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
	components: {
		LoadingButton,
	},
	data() {
		return {
			user: {
				last_name: null,
				first_name: null,
				phone: null,
				email: null,
				password: null,
				password_repeat: null,
				terms: false,
				subscribe: null,
			},
			error: null,
		};
	},
	computed: {
		...mapGetters(['getLoading']),
	},
	methods: {
		...mapMutations(['showPopup', 'setLoading']),
		...mapActions(['registerCalculate']),
		async handleRegistration() {
			this.setLoading(true);
			this.$refs.form.validate().then(async success => {
				if (success) {
					const response = await this.registerCalculate(this.user);
					this.setLoading(false);

					if (response.success) {
						this.showPopup('RegistrationSending');
					} else {
						this.$refs.form.setErrors(response.errors);
					}
				}
			});
		},
		setCheckbox(e, key) {
			this.user[key] = e.target.checked;
		},
	},
};
</script>

<style lang="scss" scoped>
.lds-ring {
	display: inline-block;
	position: absolute;
	width: 24px;
	height: 24px;
}
.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 24px;
	height: 24px;
	border: 2px solid #fff;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
